/**
 * Admin API auth: X-Admin-Api-Key from Vite env and/or localStorage (UI "שמור מפתח").
 * Used by axios interceptor for any request whose URL contains /api/admin/.
 */

const LS_KEY = "adminApiKey";

export function getViteAdminApiKey() {
  try {
    if (typeof import.meta !== "undefined" && import.meta.env?.VITE_ADMIN_API_KEY) {
      return String(import.meta.env.VITE_ADMIN_API_KEY).trim();
    }
  } catch {
    /* ignore */
  }
  return "";
}

export function getStoredAdminApiKey() {
  try {
    return localStorage.getItem(LS_KEY) || "";
  } catch {
    return "";
  }
}

export function setStoredAdminApiKey(value) {
  try {
    if (value) localStorage.setItem(LS_KEY, String(value).trim());
    else localStorage.removeItem(LS_KEY);
  } catch {
    /* ignore */
  }
}

/** Value sent as X-Admin-Api-Key: manual storage wins over build-time env (same as previous behavior). */
export function getResolvedAdminApiKey() {
  return getStoredAdminApiKey().trim() || getViteAdminApiKey();
}
